<template>
    <div id="app" v-loading="!isSSO">
        <DashBoard v-if="isLogin && isSSO"></DashBoard>
        <!-- <LoginTool v-else @login-success="loginSuccessHandler"></LoginTool> -->
    </div>
</template>

<script>
import DashBoard from './components/DashBoard.vue';
import LoginTool from './components/LoginTool.vue';
// 授权登录地址
const reqUrl = "http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=101&redirect_uri=http://www.hljsd.com&scope=code";

export default {
    name: 'App',
    data() {
        return {
            isLogin: true,
            isSSO: false
        }
    },
    components: {
        DashBoard,
        LoginTool
    },
    created() {
        // this.isSSO = true;
        // return;
        // 读取名为"myCookie"的 cookie
        const cookieValue = this.readCookie('satoken');
        if (cookieValue == null) {
            window.location.replace(reqUrl);
            return;
        }
        this.isSSO = true;
    },
    methods: {
        /**
         * 解构Cookie信息
         * @param name 
         */
        readCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
            return null;
        },
        loginSuccessHandler() {
            // 登录成功后，切换到大屏页面，并重新按照权限加载数据
            this.isLogin = true;
        }
    }
}
</script>

<style>
* {
    margin: 0;
    padding: 0;
}

#app {
    font-family: PingFangSC-Regular, sans-serif, Arial, Microsoft YaHei;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

html,
body,
#app {
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

/* 弹窗开场动画 */
@keyframes dialogWindowOpen {
    0% {
        opacity: 0;
        width: 0px;
        height: 0px;
    }

    /* 50% {
        width: 1vh;
        height: 70vh;
    } */

    100% {
        opacity: 1;
        width: 100vw;
        height: 100vh;
    }
}

/* 全局修改element-ui messageBox 确认和取消按钮的位置 */
.el-message-box__btns {
    display: flex;
    flex-direction: row-reverse;
    gap: 10px;
}

/* For Chrome, Safari, and other WebKit browsers */
::-webkit-scrollbar {
    width: 4px;
    /* 纵向滚动条宽度 */
    height: 4px;
    /* 横向滚动条高度 */
}

::-webkit-scrollbar-track {
    background: #359fa5;
    /* 滚动条轨道背景 */
}

::-webkit-scrollbar-thumb {
    background: #56fefe;
    /* 滚动条滑块背景 */
    border-radius: 6px;
    /* 滚动条滑块圆角 */
}

::-webkit-scrollbar-thumb:hover {
    background: #56fefe;
    /* 滚动条滑块悬停背景 */
}
</style>
